<template>
  <label for="s-company">企業</label>
<!--  <select id="s-company" v-model="companyId" v-on:change="setId">-->
  <select id="s-company" v-model="companyId" >
    <option v-for="v in this.companies" v-bind:key="v.key" :value="v.ID">{{ v.Name }}</option>
  </select>
</template>

<script>
import axios from "axios";
import store from '@/store'

export default {
  name: 'SelectCompany',
  props: {},
  data: function () {
    return {
      path: '/allcompany',
      // company_id: store.company_id,
      companies: {}
    }
  },
  mounted:function() {
    if (store.companies === undefined) {
      axios.get(this.path, {withCredentials: true})
          .then(res => {
            store.companies = res.data.list
            // 選択肢に0:選択を追加
            const selectZero = {ID: undefined, Name: '選択'}
            store.companies.unshift(selectZero)
            // 作成されたSelectOpstionsを代入
            this.companies = store.companies
          })
          .catch(function (error) {
            console.log(error)
          })
    }
    this.companies = store.companies
  },
  computed:{
    companyId:{
      get(){
        return store.state.company_id
      },
      set(value){
        store.commit("setCompanyId", (store.state, value))
      }
    }

  },
  methods: {
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>
